import React, { Component } from 'react';
import { Route } from "react-router-dom";
import SideBar from './SideBar';
import { _setTime } from './Function';
import DepositAccount from './Deposit.Account';
import DepositTransaction from './Deposit.Transaction';
import '../css/Deposit.css';

class Deposit extends Component {
    constructor() {
        super();
        this.state={ };
    }

    onAddTime = () => { _setTime() }

    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <SideBar onRefresh={false} />
                <div className="content-bar">
                    <Route exact path="/online/deposit" component={DepositAccount} />
                    <Route path="/online/deposit/:id" component={DepositTransaction} />
                </div>
            </div>
        );
    }
}

export default Deposit;